export class Offering {
    constructor(id, tag, products) {
        this.id = id;
        this.tag = tag;
        this.products = products;
    }
    productForIdentifier(identifier) {
        return this.products.find((object) => object.qonversionId === identifier);
    }
}
//# sourceMappingURL=Offering.js.map